import { createAction, props } from '@ngrx/store';

export const loadWhatsAppPlans = createAction(
  '[Whatsapp] Load Plans',
  props<{ masterPlans: any[] }>()
);
